import {default as cx} from "classnames"
import {Question} from "./shared/Question"

export function VerticalCheckboxPrompt({
    options,
    questionText,
    field,
    questionNumber,
    totalQuestions,
    data,
    emptyError,
    handleMultiple,
    optionLabelByValue,
    otherOptionValue,
    otherText,
    onOtherTextChange,
    isRequired = true,
}) {
    const otherSelected = otherOptionValue != null && (data ?? []).includes(otherOptionValue)

    return (
        <>
            <Question
                questionText={questionText}
                questionNumber={questionNumber}
                totalQuestions={totalQuestions}
                isRequired={isRequired}
            />
            <div className="d-flex flex-column flex-fill gap-6">
                <div className="pt-6">Select all that apply</div>
                {options.map((option, index) => {
                    const id = `${field}-${index}`
                    const checked = data?.includes(option)
                    const label = optionLabelByValue?.[options[index]] ?? option
                    return (
                        <label
                            key={index}
                            className={cx(
                                "btn btn-flex btn-light btn-active-light-primary border border-1 min-w-200px w-100",
                                emptyError ? "border-danger" : "border-primary"
                            )}
                        >
                            <input
                                id={id}
                                type="checkbox"
                                className="form-check-input me-6"
                                name={field}
                                value={option}
                                checked={checked}
                                onChange={() => handleMultiple(option)}
                            />
                            <span className="d-flex align-items-center fs-5">{label}</span>
                        </label>
                    )
                })}
                {otherSelected && (
                    <div className="w-100">
                        <input
                            name={`${field}_other`}
                            value={otherText ?? ""}
                            onChange={(evt) => onOtherTextChange?.(evt.target.value)}
                            className="form-control fs-4"
                            placeholder="Please specify"
                        />
                    </div>
                )}
                {emptyError && isRequired && (
                    <span className="text-danger mt-n5">At least one selection is required</span>
                )}
            </div>
        </>
    )
}
